import { render, staticRenderFns } from "./product_slider.vue?vue&type=template&id=b2886e4c&scoped=true&"
import script from "./product_slider.vue?vue&type=script&lang=js&"
export * from "./product_slider.vue?vue&type=script&lang=js&"
import style0 from "./product_slider.vue?vue&type=style&index=0&id=b2886e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2886e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
